import React from "react";
import { classNames } from "./library/utils/classNames";

interface AvatarProfileProps {
  name: string;
  image: string;
  company?: string;
  wide?: boolean;
}

export const AvatarProfile = ({
  name,
  image,
  company,
  wide,
}: AvatarProfileProps) => {
  return (
    <div className="flex min-w-0 flex-none items-center gap-16 truncate">
      <div
        className="h-28 w-28 shrink-0 rounded-full bg-cover bg-center md:h-40 md:w-40"
        title={name}
        style={{
          backgroundImage: `url(${image})`,
        }}
      />

      <div
        className={classNames(
          "shrink truncate",
          wide ? "flex items-center gap-8 md:gap-12" : "flex flex-col gap-4 "
        )}
      >
        <div className="truncate text-12-14 font-bold text-black dark:text-gray-300 md:text-14-16">
          {name}
        </div>
        {wide && <span className="h-4 w-4 rounded-full bg-gray-700"></span>}
        <p className="whitespace-normal text-12-14 text-gray-700 line-clamp-2 dark:text-gray-600 md:text-14-16">
          {company}
        </p>
      </div>
    </div>
  );
};
